// PLACEHOLDER DATA — replace with Supabase query.
// Represents the currently active season for display across the site.

export const activeSeason = {
  name: "Winter" as const,
  dateRange: "November 2026 — February 2027",
  heroImage:
    "https://mbqtdfdhqbpbcfqzdbso.supabase.co/storage/v1/object/public/site-assets/triumph-hero-fall-2026.jpg",
};